export default __webpack_public_path__ + "static/media/navigate_before_black.ef840762.svg";